export { default } from "./ClientSearch.js";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/ClientSearch/index.js